import React from 'react';
import { Outlet } from 'react-router-dom';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { agenticLoginRequest } from '../../config/agenticMsalConfig';

// Guards the agentic (/apps, /intake-agent, etc.) subtree with a second
// Azure AD login using the agentic app registration. The outer Track 1
// session_exists cookie gate has already run before this component mounts.
// MsalAuthenticationTemplate handles interaction_in_progress races automatically.
const AgenticProtectedRoute = () => (
  <MsalAuthenticationTemplate
    interactionType={InteractionType.Redirect}
    authenticationRequest={agenticLoginRequest}
  >
    <Outlet />
  </MsalAuthenticationTemplate>
);

export default AgenticProtectedRoute;
